export default {
  getEmployees: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/employees/getters.js